import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconIntegration: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.5 6C16.5 8.48527 14.4853 10.5 12 10.5C11.24 10.5 10.524 10.3116 9.8961 9.9789L3.375 16.5L1.5 14.625L8.0211 8.1039C7.68844 7.47604 7.5 6.76001 7.5 6C7.5 3.51472 9.51473 1.5 12 1.5C12.76 1.5 13.476 1.68842 14.1039 2.0211L11.25 4.875L13.125 6.75L15.9789 3.8961C16.3116 4.52396 16.5 5.23999 16.5 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
